import React from 'react'
import Wave from 'react-wavify'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faHeart } from '@fortawesome/free-solid-svg-icons';



export default function FooterComp() {

  return (
    
    <div className="footerBox layerIndex">
      <div className='waveContainer'>
        <Wave  className="wave" fill='#dbbff6'
          paused={false}

          options={{
            height: 60,
            amplitude: 20,
            speed: 0.2,
            points: 4
          }}
        />

        <Wave  className="wave" fill='#b87fed'
              paused={false}

              options={{
                height: 70,
                amplitude: 25,
                speed: 0.3,
                points: 5
              }}
        />

        <Wave  className="wave" fill='#8a2be2'
              paused={false}

              options={{
                height: 80,
                amplitude: 30,
                speed: 0.13,
                points: 6
              }}
        />

        <div className='footerContent'>
          {/* <p>Footer content</p>
          <div className='icons'>
            <FontAwesomeIcon icon={faHeart} className='icon' />
            <FontAwesomeIcon icon={faEnvelope} className='icon' />
          </div> */}
        </div>

        
    </div>
  </div>


  )
}
